<template>
  <div class="survey-already-completed-container">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-8-desktop is-10-tablet">
          <div class="card">
            <header class="card-header">
              <div class="card-header-title is-block has-text-centered">
                <div class="icon-wrapper success">
                  <b-icon
                    icon="check-circle"
                    size="is-large"
                    type="is-success"
                  />
                </div>
                <h1
                  class="title is-spaced is-size-2-desktop is-size-4-mobile has-text-weight-bold mt-4 mb-2"
                >
                  Ya Completaste Esta Encuesta
                </h1>
                <p
                  class="subtitle is-size-5-desktop is-size-6-mobile has-text-grey"
                >
                  Tus respuestas han sido registradas exitosamente
                </p>
              </div>
            </header>

            <div class="card-content">
              <div class="content has-text-centered">
                <p class="has-text-grey-dark mb-4" style="line-height: 1.6;">
                  Ya has completado esta encuesta anteriormente. Solo se permite
                  una participación por persona.
                </p>

                <div class="success-box">
                  <p class="is-size-7" style="line-height: 1.6;">
                    Gracias por tu participación. Tus respuestas son muy
                    valiosas para nosotros.
                  </p>
                </div>
              </div>
            </div>

            <footer v-if="showBackButton" class="card-footer">
              <div class="card-footer-item">
                <b-button
                  type="is-light"
                  size="is-medium"
                  expanded
                  @click="handleGoBack"
                >
                  Volver
                </b-button>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SurveyAlreadyCompleted",

  props: {
    showBackButton: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleGoBack() {
      this.$emit("go-back");
    },
  },
};
</script>

<style scoped>
.survey-already-completed-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background-color: #f5f5f5;
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-header-title {
  padding: 2rem 1.5rem;
}

.icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.icon-wrapper.success {
  background-color: rgba(72, 199, 142, 0.15);
}

.card-content {
  padding: 1.5rem;
}

.success-box {
  background-color: #effaf5;
  border: 1px solid #48c78e;
  border-radius: 6px;
  padding: 1rem;
  color: #257953;
}

.card-footer-item {
  padding: 1.5rem;
  display: block;
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .survey-already-completed-container {
    padding: 1rem;
  }

  .card-header-title {
    padding: 1.5rem 1rem;
  }

  .card-content {
    padding: 1rem;
  }

  .icon-wrapper {
    width: 3.5rem;
    height: 3.5rem;
  }

  .success-box {
    padding: 0.75rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/survey/SurveyAlreadyCompleted.vue